import LogicaAPI from "./logicaapi";
class PlaybackAuth extends LogicaAPI {
  async auth(_ref) {
    let {
      id,
      vuid,
      fl,
      withResumePoint,
      sessionId,
      exercise
    } = _ref;
    const params = {
      meta_id: id,
      vuid: vuid,
      fl: fl,
      with_resume_point: withResumePoint,
      service: this.config.service,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      exercise
    };
    const header = {};
    if (sessionId) {
      header["X-Playback-Session-Id"] = sessionId;
    }
    return this.post("/api/v1/playback_proxy/auth", {
      body: params
    }, header);
  }
}
export default PlaybackAuth;